import { createAuthClient } from 'better-auth/client';
import { anonymousClient } from 'better-auth/client/plugins';
import type { TelegramAuthData } from 'better-auth-telegram';
import { telegramClient } from 'better-auth-telegram/client';

// Use VITE_API_URL if set, otherwise use empty string to leverage Vite proxy
const BASE_URL = import.meta.env.VITE_API_URL || '';

export const authClient = createAuthClient({
  baseURL: BASE_URL,
  fetchOptions: {
    credentials: 'include', // required for link/unlink session cookies
  },
  plugins: [telegramClient(), anonymousClient()],
});

export type { TelegramAuthData };
